import { useEffect, useState } from 'react';
import {
  type CollectionEnvelope,
  type GuestActivation,
  guestOffersFetch,
} from '../guestOffersApi';

type RedeemedScreenProps = {
  activationId: string;
  onBackToOffers: () => void;
};

export function RedeemedScreen({ activationId, onBackToOffers }: RedeemedScreenProps) {
  const [venueName, setVenueName] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;

    guestOffersFetch<CollectionEnvelope<GuestActivation>>('/api/v1/me/offers')
      .then((response) => {
        if (cancelled) {
          return;
        }

        const activation = response.data.find((item) => item.id === activationId);
        setVenueName(activation?.venue.display_name ?? null);
      })
      .catch(() => {
        if (!cancelled) {
          setVenueName(null);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [activationId]);

  return (
    <main className="offer-result-page" aria-label="Бонус получен">
      <section className="offer-result-card panel-card">
        <div className="offer-result-icon is-success" aria-hidden="true">✓</div>
        <span className="offers-eyebrow">Готово</span>
        <h1>Вы получили бонус{venueName ? ` в ${venueName}` : ''}</h1>
        <p>Спасибо, что пользуетесь Хоппером</p>
        <button className="primary-button" type="button" onClick={onBackToOffers}>
          Вернуться в Предложения
        </button>
      </section>
    </main>
  );
}
